export const MOBILE_BREAK_POINT = 769;
